import SanctumService from './sanctumService'

export default function useSanctum(axiosIns, overrideConfig) {
  const sanctum = new SanctumService(axiosIns, overrideConfig)

  return {
    sanctum,
  }
}
